import React, { useState } from 'react';
import { AccordionItem, Box, Inscription, ShimmerBox } from '@common-fe/common-fe';

import { FAQStyledBox } from '../styles/ExpressSetupWizard.styles';

interface Props {
  isLoading?: boolean;
  question: string;
  answer: string;
  isPageMode?: boolean;
  index?: number
}

const ExpressSetupFAQItem: React.FC<Props> = ({
  isLoading,
  question, 
  answer,
  isPageMode,
  index,
}) => {
  const [isExpanded, setExpanded] = useState(false);

  return (
    <>
      {
        isLoading ? <ShimmerBox width="100%" height="76px" /> : (
          <FAQStyledBox
            data-testid={`FAQ-styled-box-${index}_id`}
            onClick={() => setExpanded(!isExpanded)}
            pad={{ vertical: isPageMode ? 'l' : 'm', horizontal: 'l' }}
            border={{ color: 'border1', size: 'large' }}
            round="container1Round"
            background={isExpanded ? 'border1' : 'canvas'}
            isPageMode={isPageMode}
          >
            <AccordionItem
              testId='express-setup-faq-anchor'
              iconSize='24px'
              isExpanded={isExpanded}
              text={(
                <Box
                  background={isExpanded ? 'border1' : 'canvas'}
                  margin={{ left: 'xxxs' }}
                  direction="row"
                  align="center"
                >
                  <Inscription color="textTitle" weight="normal" size={isPageMode ? '20px' : '16px'} lineHeight={isPageMode ? '28px' : '22px'}>
                    {question}
                  </Inscription>
                </Box>
              )}
              isLeftArrow
            >    
              <Box
                background="border1"
                margin={{ top: 'xs' }}
              >
                <Inscription color="textBody" lineHeight="20px">{answer}</Inscription>
              </Box>
            </AccordionItem>
          </FAQStyledBox>
        )
      }
    </>
  );
};
export default ExpressSetupFAQItem;
